import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { NuovoEvento, SchedaEvento } from "@/pages/calendario/EventoDialog";
import { fmtEvento, TIPI_EVENTO, scelteNuovo } from "@/pages/calendario/calendarioComuni";

// Sprint CRM-2B — eventi collegati: li vede chiunque veda l'opportunità; nuova attività già collegata, personale
export default function AttivitaOpportunita({ o, onCambio }) {
  const { user } = useAuth() || {};
  const [voci, setVoci] = useState([]);
  const [cal, setCal] = useState(null);
  const [nuova, setNuova] = useState(false);
  const [aperta, setAperta] = useState(null);
  const carica = useCallback(() => api.get(`/crm/opportunita/${o.id}/attivita`).then((r) => setVoci(r.data)).catch(() => setVoci([])), [o.id]);
  useEffect(() => { carica(); api.get("/calendario/calendari").then((r) => setCal(r.data)).catch(() => {}); }, [carica]);
  const scelte = cal ? scelteNuovo(cal, user).filter((c) => c.calendario === "personale" && c.company_id === o.company_id) : [];
  const apri = (v) => api.get(`/calendario/eventi/${v.id}`).then((r) => setAperta(r.data)).catch(() => {});
  const fatto = () => { setNuova(false); setAperta(null); carica(); onCambio(); };
  return (
    <Card className="p-4 space-y-2" data-testid="crm-opp-attivita">
      <div className="flex justify-between items-center">
        <div className="font-heading text-sm uppercase text-slate-500 tracking-wide">Attività</div>
        <Button size="sm" onClick={() => setNuova(true)} disabled={!scelte.length} data-testid="crm-opp-nuova-attivita"><Plus className="h-4 w-4 mr-1" /> Nuova attività</Button>
      </div>
      {!voci.length && <div className="text-sm text-slate-400">Nessuna attività</div>}
      {voci.map((v) => (
        <button key={v.id} type="button" onClick={() => apri(v)} className="w-full text-left border-t pt-2 text-sm flex gap-3 hover:bg-slate-50" data-testid={`crm-attivita-${v.id}`}>
          <span className="font-mono w-36 shrink-0">{fmtEvento(v)}</span>
          <span className="flex-1 min-w-0">{v.titolo} <span className="text-xs text-slate-500">· {TIPI_EVENTO[v.tipo]} · {v.assegnatario || "Sede"}</span>
            {v.descrizione && <span className="block truncate text-xs text-slate-500" title={v.descrizione} data-testid={`crm-attivita-descrizione-${v.id}`}>{v.descrizione}</span>}</span>
          <span className={`text-xs ${v.fatto ? "text-emerald-700" : "text-amber-700"}`}>{v.fatto ? `Fatto${v.esito ? ` · ${v.esito}` : ""}` : "Da fare"}</span>
        </button>
      ))}
      {nuova && <NuovoEvento scelte={scelte} opportunita={o} onChiudi={() => setNuova(false)} onFatto={fatto} />}
      {aperta && <SchedaEvento ev={aperta} onChiudi={() => setAperta(null)} onFatto={fatto} />}
    </Card>
  );
}
